import { UPDATE_EDITING_NOTE } from 'constants/action_types'

export default function doUpdateEditingNote(noteId, content) {
  return {
    type: UPDATE_EDITING_NOTE,
    data: { noteId, noteText: content },
  }
}
